<template>
  <div>
    <!--<p>로그 수: {{ logs.length }}</p>
    <LogBox v-if="!loading" :logs="logs" />-->
    <footer>
      <div class="footer_container">
        <div class="others_info">
          {{ footerText }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import LogBox from '@/components/common/LogBox.vue';

const host = window.location.hostname;
export default {
  components: { LogBox },
  computed:{
    footerText() {
      if (host.includes(`omarket.kr`)) {
        return [
         /* `주식회사 셀리오마켓`,
          `대표: 이광성`,
          `사업자명: 주식회사 셀리오마켓`,
          `사업자번호: 347-87-03469`,
          `주소: 서울특별시 구로구 디지털로26길, 43 알동 1102-에이188호`,
          `통신판매업: 제2021-서울강서-3181호`,
          `Copyright 2024. omarket. All rights reserved.`*/
          `하이큐`,
          `대표: 이영호`,
          `사업자명: 하이큐`,
          `사업자번호: 276-12-02461`,
          `주소: 서울특별시 성북구 아리랑로5길 25,102동 1101호(동소문동7가,브라운스톤동선)`,
          `통신판매업: 2023-서울성북-0425`,
          `TEL: 010-5734-5400`,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      } else if (host.includes(`shcolab.co.kr`)) {
        return [
          `주식회사 시행착오`,
          `대표: 박성민`,
          `사업자명: 주식회사 시행착오`,
          `사업자번호: 714-88-03370`,
          `주소: 서울특별시 성동구 왕십리21길9, 3층(행당동)`,
          `통신판매업: `,
          `(솔루션 개발사 : (주)셀리오마켓 (347-87-03469)`
        ];
      } else if (host.includes(`kimmanager.co.kr`)) {
        return [
          `주식회사 정군`,
          `대표: 정호준`,
          `사업자명: 주식회사 정군`,
          `사업자번호: 675-87-02763`,
          `주소: 경기도 김포시 김포대로 709, 11층 1101호(풍무동, 퍼스트블루)`,
          `통신판매업: `,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      } else if (host.includes(`withjikkoo.kr`)) {
        return [
          `찬솔루션`,
          `대표: 임휘영`,
          `사업자명: 찬솔루션`,
          `사업자번호: 597-07-01521`,
          `주소: 경기도 안양시 만안구 덕천로 152번길 25 A동 27-03`,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      } else if (host.includes(`kcode.store`)) {
        return [
          `케이스톰`,
          `대표: 김동완`,
          `사업자명: 케이스톰`,
          `사업자번호: 315-22-03842`,
          `주소: 서울 마포구 동교로 171, 1층`,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }else if (host.includes(`overlink.kr`)) {
      return [
        `(주) 에스지비솔루션`,
        `대표: 심덕은`,
        `사업자명: 에스지비솔루션`,
        `사업자번호: 347-87-03469 `,
        `주소: 서울 구로구 디지털로26길 43 알동 1102-에이188호 (구로동, 대륭포스트타워8차)`,
        `통신판매 : 2025-서울구로-0978`,
        'TEL: ',
        `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
      ];
    }else if (host.includes(`crosssell.co.kr`)) {
        return [
          `(주) 엔솔로지`,
          `대표: 변재영`,
          `사업자명: (주) 엔솔로지`,
          `사업자번호: 507-86-03706`,
          `주소: 서울  성동구 연무장13길, 705호(성수동2가,통일타워)`,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }else if (host.includes(`zijyasssssell.com`)) {
        return [
          `지쟈쓰 비즈니쓰 오피쓰`,
          `대표: 이근영`,
          `사업자명: 지쟈쓰 비즈니쓰 오피쓰`,
          `사업자번호: 708-28-01766`,
          `주소: 인천 광역시 부평구 주부토로 236, B동 18층 17호(갈산동 인천테크노밸리U1센터) `,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }else if (host.includes(`osonupload.com`)) {
        return [
          `오라인`,
          `대표: 오인걸`,
          `사업자명: 오라인`,
          `사업자번호: 302-18-02495`,
          `주소: 서울특별시 금천구 디지털로10길 37, 1330호(가산동) `,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }else if (host.includes(`smartcross.kr`)) {
        return [
          `스마트크로스`,
          `대표: `,
          `사업자명: 스마트크로스`,
          `사업자번호: `,
          `주소: `,
          ``,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }
      else {
        return [
          `주식회사 파트너코퍼레이션`,
          `대표: 홍길동`,
          `사업자명: 주식회사 파트너코퍼레이션`,
          `사업자번호: 123-45-67890`,
          `주소: 서울시 강남구 테헤란로 123`,
          `통신판매업: 제2022-서울강남-0000호`,
          `(솔루션 개발사 : (주)에스지비솔루션 (347-87-03469)`
        ];
      }
    },
    logs() {
      return [
        ...this.socketStore.collectList.map(log => ({ ...log, type: '상품수집' })),
        ...this.socketStore.uploadList.map(log => ({ ...log, type: '마켓업로드' })),
        ...this.socketStore.stockLinkList.map(log => ({ ...log, type: '재고' })),
        ...this.socketStore.deleteResultList.map(log => ({ ...log, type: '삭제' }))
      ].map(log => ({
        ...log,
        timestamp: log.regDate || log.timestamp || new Date()
      })).sort((a, b) => b.timestamp - a.timestamp);
    }
  }
  /*mounted() {
    if (host.includes('localhost') || host.includes('omarket.kr')) {
      (function() {
        var w = window;
        if (w.ChannelIO) {
          return w.console.error('ChannelIO script included twice.');
        }
        var ch = function() {
          ch.c(arguments);
        };
        ch.q = [];
        ch.c = function(args) {
          ch.q.push(args);
        };
        w.ChannelIO = ch;

        function l() {
          if (w.ChannelIOInitialized) {
            return;
          }
          w.ChannelIOInitialized = true;
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
          var x = document.getElementsByTagName('script')[0];
          if (x.parentNode) {
            x.parentNode.insertBefore(s, x);
          }
        }

        if (document.readyState === 'complete') {
          l();
        } else {
          w.addEventListener('DOMContentLoaded', l);
          w.addEventListener('load', l);
        }
      })();
      window.ChannelIO('boot', {
        pluginKey: 'f194d881-b146-469c-8d41-15ddc5151414'
      });
    }
  }*/
};
</script>

<style lang="scss">
@import '@/assets/style/app/layout/footer.scss';
</style>
